import { getDefaultMix } from "@project-rouge/rg-core";
import { aggRulesWeightDefaults } from "./index132.js";
function getDefaultAggRulesProps(dataset) {
  return {
    targetUnitMix: getDefaultMix(dataset),
    canCloseEnds: [true, true],
    targetEntranceCount: 0,
    hasEntryAtStart: false,
    hasCornerAt: [false, false],
    distToCore: [0, 0],
    targetFireCoreCount: 0,
    targetLiftCoreCount: 0,
    targetStairCoreCount: 0,
    skipCores: true,
    maxCorridorDists: {
      start: dataset.aggConfig.maxTravelDistSprinklered,
      middle: dataset.aggConfig.maxTravelDistBidirectional * 2,
      end: dataset.aggConfig.maxTravelDistSprinklered
    },
    endClosingDistances: [0, 0],
    endEntranceDistances: [Infinity, Infinity],
    // default to not considering any blocking on the opposite side
    lockEnds: [true, false],
    weights: aggRulesWeightDefaults,
    isDoubleLoaded: true
  };
}
export {
  getDefaultAggRulesProps
};
//# sourceMappingURL=index129.js.map
